export enum GameModeEnum {
    AM = 1,
    CM = 2,
    MID1V1 = 21
}